// Library
import React from "react";
import { Route, Redirect } from "react-router-dom";

// Functions/ Services
import { isLoggedIn } from "../Services/UserAuth/UserAuthenticate";

const PrivateRoutes = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        isLoggedIn() ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/auth/login",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};
export default PrivateRoutes;
